import { components } from 'type/ReportServiceSchema';
import {
  BenchmarkRelativeScoreModel,
  mapBenchmarkRelativeScoreDtoToModel,
} from 'api/dto/new/Common/BenchmarkRelativeScore.dto';
import { FeedbackModel, mapFeedbackDtoToModel } from 'api/dto/new/Common/Feedback.dto';
import {
  ImpactOnEngagementLabelModel,
  mapImpactOnEngagementLabelDtoToModel,
} from 'api/dto/new/Common/ImpactOnEngagementLabel.dto';
import {
  mapTrendRelativeScoreDtoToModel,
  TrendRelativeScoreModel,
} from 'api/dto/new/Common/TrendRelativeScore.dto';
import {
  mapTrendQuestionDtoToModel,
  TrendQuestionModel,
} from 'api/dto/new/Common/TrendQuestion.dto';
import {
  mapOpinionQuestionDtoToModel,
  OpinionQuestionModel,
} from 'api/dto/new/Common/OpinionQuestion.dto';

export type DetailWithTrendQuestionDto = components['schemas']['DetailWithTrendQuestion'];

export type DetailWithTrendQuestionModel = {
  score: number;
  benchmark: BenchmarkRelativeScoreModel;
  confidentialityProtection: boolean;
  count: number;
  feedback: FeedbackModel[];
  impactOnEngagement?: ImpactOnEngagementLabelModel | null;
  impactOnEngagementScore?: number | null;
  question: OpinionQuestionModel;
  trends: TrendRelativeScoreModel[];
  trendQuestion?: TrendQuestionModel | null;
};

export const mapDetailWithTrendQuestionDtoToModel = (
  dto: DetailWithTrendQuestionDto
): DetailWithTrendQuestionModel => {
  return {
    score: dto.score,
    benchmark: mapBenchmarkRelativeScoreDtoToModel(dto.benchmark),
    confidentialityProtection: dto.confidentialityProtection,
    count: dto.count,

    feedback: dto.feedback.map(mapFeedbackDtoToModel),
    impactOnEngagement: dto.impactOnEngagement
      ? mapImpactOnEngagementLabelDtoToModel(dto.impactOnEngagement)
      : null,
    impactOnEngagementScore: dto.impactOnEngagementScore,
    question: mapOpinionQuestionDtoToModel(dto.question),

    trends: dto.trends.map(mapTrendRelativeScoreDtoToModel),
    trendQuestion: dto.trendQuestion ? mapTrendQuestionDtoToModel(dto.trendQuestion) : null,
  };
};
